import { EffectiveCart } from 'interfaces/cart';
import isNumber from 'lodash/isNumber';
import sum from 'lodash/sum';

/**
 * Returns the total amount saved by sale pricing on items with a `compareAtPrice`.
 */
export const getSaleSavingsAmount = (effectiveCart: EffectiveCart): number => {
  const saleItems = effectiveCart.items
    .filter((item) => isNumber(item.compareAtPrice))
    .map((item) => (item.compareAtPrice! - item.defaultPrice) * item.quantity);
  return sum(saleItems);
};
